import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';

@Component({
  selector: 'gtd-ui-field-default-string-whitespace-or-empty',
  templateUrl: './string-whitespace-or-empty.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StringWhitespaceOrEmptyComponent implements OnInit {
  get data(): any {
    return this.dataValue;
  }
  @Input() set data(value: any) {
    switch (true) {
      case typeof value === 'number':
      case typeof value === 'boolean':
        this.dataValue = value + '';
        break;
      case value === null:
      case value === undefined:
        this.dataValue = '';
        break;
      default:
        this.dataValue = value;
        break;
    }
  }
  @Input() length = 30;
  @Input() jsonProp: string | number;
  private dataValue: any;

  public ngOnInit(): void {
    if (this.jsonProp !== undefined) {
      try {
        this.data = JSON.parse(this.data)[this.jsonProp];
      } catch {}
    }
  }
}
